// Imports
import styled from 'styled-components/macro';


// Styled component
interface Props {
	size: string;
}

const ProfilePhoto = styled.img<Props>`
	display: block;
	width: ${({ size }) => size};
	height: ${({ size }) => size};
	border-radius: 50%;
	box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.1);
`;

export default ProfilePhoto;
